import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Suspense, lazy } from "react";

import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import "bootstrap-icons/font/bootstrap-icons.css";

import Loading from "./components/Loading";
import ErrorPage from "./pages/ErrorPage";

const Home = lazy(() => import("./pages/Home"));
const QRScanner = lazy(() => import("./pages/QRScanner"));
const Login = lazy(() => import("./pages/Login"));
const Logintelp = lazy(() => import("./components/Form/LoginTelpForm"));
const Register = lazy(() => import("./pages/Register"));
const Verification = lazy(() => import("./pages/Verification"));
const Verificationlogin = lazy(() => import("./pages/VerificationLogin"));
const Menu = lazy(() => import("./pages/Menu"));
const Favorite = lazy(() => import("./pages/Favorite"));
const Checkout = lazy(() => import("./pages/Checkout"));
const Voucher = lazy(() => import("./pages/Voucher"));
const Receipt = lazy(() => import("./pages/Receipt"));
const Survey = lazy(() => import("./pages/Survey"));
const Payment = lazy(() => import("./pages/Payment"));
const Layanan = lazy(() => import("./pages/Layanan"));
const Table = lazy(() => import("./pages/Table"));
const Profile = lazy(() => import("./pages/Profile"));
const History = lazy(() => import("./pages/History"));
const DetailHistory = lazy(() => import("./pages/DetailHistory"));
const EditProfile = lazy(() => import("./pages/EditProfile"));

const fallback = () => {
  return <Loading background_color={"white"} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route exact path="/">
            <Suspense fallback={fallback()}>
              <Home pageName="home" />
            </Suspense>
          </Route>
          <Route exact path="/qrscanner">
            <Suspense fallback={fallback()}>
              <QRScanner pageName="qrscanner" />
            </Suspense>
          </Route>
          <Route exact path="/login">
            <Suspense fallback={fallback()}>
              <Login pageName="login" />
            </Suspense>
          </Route>
          <Route exact path="/logintelp">
            <Suspense fallback={fallback()}>
              <Logintelp pageName="logintelp" />
            </Suspense>
          </Route>
          <Route exact path="/register">
            <Suspense fallback={fallback()}>
              <Register pageName="register" />
            </Suspense>
          </Route>
          <Route exact path="/verification">
            <Suspense fallback={fallback()}>
              <Verification pageName="verification" />
            </Suspense>
          </Route>
          <Route exact path="/verificationlogin">
            <Suspense fallback={fallback()}>
              <Verificationlogin pageName="verificationlogin" />
            </Suspense>
          </Route>
          <Route exact path="/menu">
            <Suspense fallback={fallback()}>
              <Menu pageName="menu" />
            </Suspense>
          </Route>
          <Route exact path="/favorite">
            <Suspense fallback={fallback()}>
              <Favorite pageName="favorite" />
            </Suspense>
          </Route>
          <Route exact path="/checkout">
            <Suspense fallback={fallback()}>
              <Checkout pageName="checkout" />
            </Suspense>
          </Route>
          <Route exact path="/voucher">
            <Suspense fallback={fallback()}>
              <Voucher pageName="voucher" />
            </Suspense>
          </Route>
          <Route exact path="/receipt">
            <Suspense fallback={fallback()}>
              <Receipt pageName="receipt" />
            </Suspense>
          </Route>
          <Route exact path="/survey">
            <Suspense fallback={fallback()}>
              <Survey pageName="survey" />
            </Suspense>
          </Route>
          <Route exact path="/payment">
            <Suspense fallback={fallback()}>
              <Payment pageName="payment" />
            </Suspense>
          </Route>
          <Route exact path="/table">
            <Suspense fallback={fallback()}>
              <Table pageName="table" />
            </Suspense>
          </Route>
          <Route exact path="/layanan">
            <Suspense fallback={fallback()}>
              <Layanan pageName="layanan" />
            </Suspense>
          </Route>
          <Route exact path="/profile">
            <Suspense fallback={fallback()}>
              <Profile pageName="profile" />
            </Suspense>
          </Route>
          <Route exact path="/edit_profile">
            <Suspense fallback={fallback()}>
              <EditProfile pageName="edit_profile" />
            </Suspense>
          </Route>
          <Route exact path="/history">
            <Suspense fallback={fallback()}>
              <History pageName="history" />
            </Suspense>
          </Route>
          <Route exact path="/detail_history">
            <Suspense fallback={fallback()}>
              <DetailHistory pageName="detail_history" />
            </Suspense>
          </Route>
          <Route exact path="*">
            <ErrorPage pageName="error_page" />
          </Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
